"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.features = {
    singleword_benchmark: {
        name: 'Yes/No/Spoken Digit Benchmark',
        storageKey: 'hideTargetSegmentBanner',
        configFlag: 'BENCHMARK_LIVE',
        locales: [
            'en',
            'ar',
            'ca',
            'cy',
            'da',
            'de',
            'eo',
            'es',
            'eu',
            'fr',
            'id',
            'ja',
            'nl',
            'pl',
            'pt',
            'ru',
            'ta',
            'tr',
            'tt',
        ],
    },
};
//# sourceMappingURL=feature.js.map